import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../_metronic/layout";
import { SplashScreen } from "../../../_metronic/_partials/controls";
import B2CDashboard from "./B2CDashboard";
import WholesaleDashboard from "./WholesaleDashboard";

export default function AllDashboardPages() {
  return (
    <Suspense fallback={<SplashScreen />}>
      <Switch>
        {<Redirect exact from="/dashboard" to="/dashboard/b2c" />}
        <ContentRoute path="/dashboard/b2c" component={B2CDashboard} />
        <ContentRoute
          exact
          path="/dashboard/wholesale"
          component={WholesaleDashboard}
        />
      </Switch>
    </Suspense>
  );
}
